

















import { Vue, Component } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { mapState, mapGetters } from "vuex";
import Navbar from "./components/Navbar.vue";
import Notifications from "./components/Notifications.vue";

@Component({
  components: {
    Navbar,
    Notifications
  }
})
export default class App extends Vue {
  @State(state => state.app.notifications) notifications: any;
  @Getter("user/isAuth") isAuth: any;
}
